import React from "react";

import styles from "../signupastutor/style/totalcal.module.css";

const Totalcal = () => {
  return (
    <>
      <div className={styles.containertotal}>
        <div className={styles.innercontainer}>
          <div className={styles.forstudent}>
            <div className={styles.totalstudent}>
              <h2>5500+</h2>
            </div>
            <div className={styles.totalstudenttext}>
              <h4>students</h4>
            </div>
          </div>

          <div className={styles.divider}>
            <h2>|</h2>
          </div>

          <div className={styles.fortutor}>
            <div className={styles.totalverifytutor}>
              <h2>7500+</h2>
            </div>
            <div className={styles.totalverifytutortext}>
              <h4> Verified Tutors</h4>
            </div>
          </div>
          <div className={styles.divider}>
            <h2>|</h2>
          </div>

          <div className={styles.forreview}>
            <div className={styles.totalreview}>
              <h2>7500+</h2>
            </div>
            <div className={styles.totalreviewtext}>
              <h4>Reviews</h4>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Totalcal;
